import { makeHttpRequest } from "@/shared";

import { mapCalculatedRentFromServer } from "./mappers/mapCalculatedRentFromServer";

export const removeDiscountFromRent = async (sessionKey, temporaryKey) => {
    const response = (
        await makeHttpRequest({
            url: `/rent/builder/${sessionKey}/remove/discount`,
            method: "DELETE",
            params: {
                temporary_key: temporaryKey,
            },
        })
    ).data;

    return mapCalculatedRentFromServer(response.data);
};
